import { create } from 'zustand';

interface ChatUIState {
  opened: boolean;
  unreadCount: number;
  stagedClaimID: string | null;
  setOpened: (opened: boolean) => void;
  setUnreadCount: (unreadCount: number) => void;
  stageClaim: (claimID: string) => void;
  clearStagedClaim: () => void;
  toggle: () => void;
}

export const useChatUIStore = create<ChatUIState>((set) => ({
  opened: false,
  unreadCount: 0,
  stagedClaimID: null,
  setOpened: (opened) => set({ opened }),
  setUnreadCount: (unreadCount) => set({ unreadCount }),
  stageClaim: (stagedClaimID) => set({ stagedClaimID, opened: true }),
  clearStagedClaim: () => set({ stagedClaimID: null }),
  toggle: () => set((state) => ({ opened: !state.opened })),
}));
